import { useMutation, useQueryClient } from '@tanstack/react-query';

import { updateSupplierDocuments } from '../../common/api/clients/supplierOnboarding.api';
import { queries } from '../../common/api/queryKeys/queries';

interface UpdateSupplierDocumentsVariables {
    offerId: string;
    fileIds: string[];
}

export const useUpdateSupplierDocuments = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: ({ offerId, fileIds }: UpdateSupplierDocumentsVariables) =>
            updateSupplierDocuments(offerId, fileIds),
        onSuccess: (onboarding) => {
            queryClient.setQueryData(
                queries.supplierOnboarding.byRequestForQuoteId(onboarding.requestForQuoteId).queryKey,
                onboarding
            );
        },
        onError: () => {
            queryClient.invalidateQueries({
                queryKey: queries.supplierOnboarding._def,
            });
        },
    });
};
